import './Layout.css';

import React from 'react';

const Layout = ({ children }) => <div className="common-container">{children}</div>;

export default Layout;
